<template>
  <div style="display: none;">
    <div id="printMe">
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="width : 75mm;  height: 38mm; max-height: 38mm;"
      >
        <div v-if="product.distinguish != 'distinguish'" :style="style">
          <table
            style="width: 75mm; height: 38mm; padding-top: 40px; padding-left: 32px;"
          >
            <tr style="display: flex;">
              <td style="width: 20mm;">
                <qrcode-vue
                  :value="product.url"
                  level="H"
                  :renderAs="renderAs"
                  :size="QrCodeSize"
                ></qrcode-vue>
              </td>
              <td style="padding-left: 5px; padding-top: 21px; width: 40mm;">
                <p
                  style="font-size: 12px; padding:0px; margin:0px; text-align: center; height: 20px; width: 100%; display: flex;"
                >
                  <font
                    class="poppine-font"
                    style="font-size: 12px; font-weight:500; width: 100%; align-items: center; display: flex; justify-content: center;"
                    >{{ product.authCode }}</font
                  >
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; width : 55mm; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm; text-align: left;"
            >
              인쇄매수 : {{ product.variantPrintCount }} ▲
            </p>
            <div style="width : 52mm;">
              <p
                style="margin:0px; padding:0px; width : 55mm; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >
                {{ product.productName }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: left;"
              >
                옵션 : {{ product.variantName }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left;"
              >
                상품코드 : {{ product.productCode }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 11px; text-align: left;"
              >
                품목코드 : {{ product.variantCode }}
              </p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";
import kocorp_75_38 from "@/assets/authservice/custom_print_images/kocorp_75_38.png";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/CustomKocorpLabelType1.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "http://m." + store.state.mallId + ".cafe24.com",
      QrCodeSize: "70",
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      style: `background-image: url("${kocorp_75_38}"); background-size: 75mm 38mm;`,
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      let idx = 0;
      this.productInfos = [];
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name,
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0,
          };
          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (var j = 0; j < data[productCode][variantCode][i][0].print_count; j++) {
              let productName = data[productCode][variantCode][i][0].product_name;
              let variantName = data[productCode][variantCode][i][0].variant_name;
              let serialNumber = data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(
                encodeURI(data[productCode][variantCode][i][0].serial_number)
              );
              let _url = "http://m." + store.state.mallId + ".cafe24.com/royalty.html";
              // 대표도메인 있으면 대표도메인으로
              if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
                _url =
                  "http://" +
                  sessionStorage.getItem(`${this.$store.state.mallId}_domain`) +
                  "/royalty.html";
              }
              let QrData = {
                id: this.listCount,
                url: _url + "?authQrCode=" + encrySerialNumber,
                authCode: serialNumber,
                productName: productName,
                variantName,
              };
              this.productInfos.push(QrData);
              this.listCount++;
              if (!this.productInfos[idx].variantPrintCount) {
                this.productInfos[idx].variantPrintCount = 0;
              }
              distinguishData["variantPrintCount"]++;
            }
          }
          this.productInfos.push(distinguishData);
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {},

    cutProductName: function(text) {
      return text.substr(0, 15);
    }
  },
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  },
};
</script>

<style>
.poppine-font {
  font-size: 5px !important;
  zoom: 0.7;
}
</style>
